import type { AssetHandler } from '../../assetTypes';
import type { IAssetFile } from '../assetHandler';
import type { DropPayload } from '@/editor/core/dragDropTypes';
import type * as THREE from 'three';

import { store } from '@/editor/store';
import { editorStore } from '@/editor/store/editorStore';

/**
 * Handler for Animation Config assets (.anim.json files)
 */
export class AnimationConfigHandler implements AssetHandler {
  async handleSelect(asset: IAssetFile): Promise<void> {
    store.setSelectedAssetItem(asset);
  }

  async handleOpen(asset: IAssetFile): Promise<void> {
    // Open the animation config dialog
    editorStore.openAnimationConfigEditor(asset.path);
  }

  async handleDragEnter(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
    // Not implemented yet
  }

  async handleDragOver(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
    // Not implemented yet
  }

  async handleDragCancel(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
    // Not implemented yet
  }

  async handleDrop(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
    // Not implemented yet
  }

  getTargetObject(): unknown {
    return undefined;
  }
}

